<template lang="html">
  <content-block :controls="controls" :fresh="block.edit" @edit="editBlock()" @input="saveChanges()" @remove="deleteBlock()">
    <div v-if="edit">
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_table_title_label') }}</label>
        <div class="col-md-9">
          <input type="text" class="form-control" v-model="block.data.title" />
        </div>
      </div>
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_table_rows_count_label') }}</label>
        <div class="col-md-9">
           <button class="btn btn-sm btn-default" @click.prevent="removeRow()">-</button>
            {{ block.data.rowsCount }}
           <button class="btn btn-sm btn-default" @click.prevent="addRow()">+</button>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_table_columns_count_label') }}</label>
        <div class="col-md-9">
          <button class="btn btn-sm btn-default" @click.prevent="removeColumn()">-</button>
          {{ block.data.columnsCount }}
           <button class="btn btn-sm btn-default" @click.prevent="addColumn()">+</button>
        </div>
      </div>
      <div class="row">
        <label class="col-md-12">{{ $t('content_block_table_content_label') }}</label>

        <div class="col-md-12">
          <table class="table table-striped table-bordered">
            <tbody>
              <tr v-for="r in block.data.rowsCount">
                <td v-for="c in block.data.columnsCount">
                  <input type="text" class="form-control" v-model="block.data.data[r - 1][c - 1]" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else="edit" class="content_block__table cb_table">
      <div class="cb_table__title">{{ block.data.title }}</div>
      <table class="cb_table__table">
      <tbody>
        <tr v-for="r in block.data.rowsCount" class="cb_table__row">
          <td v-for="c in block.data.columnsCount" class="cb_table__cell">
            {{ block.data.data[r - 1][c - 1] }}
          </td>
        </tr>
      </tbody>
      </table>
    </div>
  </content-block>
</template>

<script>
  import ContentBlock from './ContentBlock'
  import PictureInput from 'vue-picture-input'
  import { Form } from 'vform'

  export default {
    components: {
      ContentBlock
    },
    name: "ContentBlockTable",
    props: {
      block: {
        type: Object,
      },
      options: {
        type: Object,
        default: () => ({
          postImageUrl: '/upload/post'
        })
      },
      controls: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        edit: false
      }
    },
    mounted () {
      if (this.controls) {
        this.edit = this.block.edit || false;
      }
    },
    methods: {
      editBlock () {
        this.edit = true;
      },
      deleteBlock () {
        this.$emit('remove')
      },
      saveChanges() {
        this.edit = false;
        this.$emit('input', this.block)
      },
      addRow() {
        this.block.data.rowsCount++;

        let row = [];
        for (let i = 0; i < this.block.data.columnsCount; i++) {
          row.push('');
        }
        this.block.data.data.push(row);
      },
      removeRow() {
        this.block.data.rowsCount = this.block.data.rowsCount > 1 ? this.block.data.rowsCount - 1 : 1;
      },
      addColumn() {
        this.block.data.columnsCount++;

        this.block.data.data.forEach(row => {
          row.push(
            ''
          );
        });
      },
      removeColumn() {
        this.block.data.columnsCount = this.block.data.columnsCount > 1 ? this.block.data.columnsCount - 1 : 1;
      },
    }
  }
</script>
